import AddressLookup from "../app/AddressLookup";

/**
 * Shared chrome for the redesigned marketing pages.
 *
 * The pages are "boxed": a 1440px shell with 40px gutters, and each section is
 * its own rounded card on the grey desk. Radii stay inside 6/8/12px
 * (rounded-md / rounded-lg / rounded-xl).
 *
 * Heroes are deliberately NOT in here — each page has its own video and its own
 * overlay strength, and they get tuned independently.
 */
export const SHELL = "mx-auto w-full max-w-[1440px] px-5 sm:px-10";
export const BOX = "rounded-xl px-6 py-9 sm:px-12 sm:py-24";
export const ARTICLEBOX = "rounded-xl px-6 py-24 sm:px-12 sm:py-24";
export const KICKER = "font-mono text-[11px] uppercase tracking-[0.14em]";
export const H2 =
  "font-display text-[2.1rem] font-light leading-[1.03] -tracking-[0.03em] sm:text-5xl lg:text-[3.75rem]";
export const H3 =
  "font-display text-[1.6rem] font-light leading-[1.03] -tracking-[0.03em] sm:text-5xl lg:text-[3rem]";
export const HAIRLINE = "border-zp-ink/[0.09]";

/* Re-exported so marketing files can keep importing their tokens from one
   place. The definition, and the contrast reasoning behind it, live in
   constants/linkStyle.js alongside the app variant. */
export { ARROW_NUDGE, INK_BUTTON, LINK } from "../../constants/linkStyle";

/**
 * The address entry point.
 *
 * A working lookup, not a link. It used to be the latter on the reasoning that
 * geocoding needs the Maps key and only the app bundle had it — which was wrong
 * about the key (one build-time inline, available to every chunk) and right
 * only about the SDK, which `AddressLookup` loads on demand. Picking a
 * suggestion or submitting typed text both land on the result page.
 *
 * The styling lives with the field rather than here because both surfaces have
 * to agree on it: a marketing page and the zero state showing two different
 * address bars was the drift this replaces.
 */
export function AddressField({ action = "Check my water" }) {
  return <AddressLookup variant="marketing" action={action} deferred />;
}
